import { useLocation, useHistory } from 'react-router-dom';

const useUrlFiltersHelper = () => {
  const { search } = useLocation();
  const history = useHistory();
  const queryString = new URLSearchParams(search);

  const replaceHistory = () => {
    const newQueryString = queryString.toString();
    if (newQueryString.length > 0) {
      history.replace(`?${newQueryString}`);
    } else {
      history.replace('.');
    }
  };

  const getIdsFromUrl = (parameter: string) => queryString.get(parameter)?.split(',') || [];

  const addToUrl = (parameter: string) => (id: string) => {
    const filterIds = getIdsFromUrl(parameter);
    if (filterIds.filter(filterId => filterId === id).length > 0) return;

    queryString.set(parameter, [...filterIds, id].join(','));
  };

  const removeFromUrl = (parameter: string) => (id: string) => {
    const urlIds = getIdsFromUrl(parameter);

    const ids = urlIds.filter(urlId => urlId !== id);
    if (ids.length === 0) {
      queryString.delete(parameter);
    } else {
      queryString.set(parameter, ids.join(','));
    }
  };

  const addEnabledFilter = addToUrl('enabledFilters');
  const addSelectedFilter = addToUrl('selectedFilters');
  const removeSelectedFilter = removeFromUrl('selectedFilters');
  const removeEnabledFilter = removeFromUrl('enabledFilters');
  const getEnabledFilters = () => getIdsFromUrl('enabledFilters');
  const getSelectedFilters = () => getIdsFromUrl('selectedFilters');

  return {
    addEnabledFilter,
    addSelectedFilter,
    removeEnabledFilter,
    removeSelectedFilter,
    getEnabledFilters,
    getSelectedFilters,
    replaceHistory
  };
};

export default useUrlFiltersHelper;
